export default "__VITE_ASSET__BY57xaSC__"